module.exports = __webpack_public_path__ + "img/banner1.38b82302.jpg";